import {useContext, useEffect, useRef, useState} from 'react'
import {APiUrbit} from '../../../../services/api/apiUrbit'
import { formatNumber} from '../../../explorer/components/common'
import {DataContext} from '../../context/DataContext'
import {OverlayTrigger, Tooltip} from 'react-bootstrap'
import BoxValores from './box'
import {BoxGaugue} from '../../../explorer/components/Map/LayoutControl/Relatorios/components/BoxGaugue'
import SegmentedProgressBar from '../../../explorer/components/Map/LayoutControl/Relatorios/components/SegmentedProgressBar'
import {BsFillCaretDownFill, BsFillCaretUpFill} from 'react-icons/bs'
import useGeometria from '../../hooks/useGeometria'
import * as turf from '@turf/turf'
import { FilterContext } from '../../context/FilterContext'
import { Geometry } from '../Types'
type props = {
  onChange: any
}
const api = new APiUrbit()

export type PropsResultado = {
  info: any
  servico: string
  distancia: number
  nome: string
  resultado: any
  tipo?: string
  key?: string
  format?: (data: any) => any
}[]

export default function CheckServices({onChange}: props) {
  const [resultado, setResultado] = useState<PropsResultado>()
  const {setCacheResult} = useContext(DataContext)
  const {geometriaSelecionada} = useContext(FilterContext)
  // const {geometria} = useGeometria()
  const lastGeomRequestRef = useRef<string>(null)

  useEffect(() => {
    async function loadservice() {
      const servicos = [
        // {
        //   servico: 'area-vulnerabilidade',
        //   distancia: 500,
        //   nome: 'Area de Vulnerabilidade',
        //   resultado: null,
        //   tipo: 'qtde',
        //   info: 'comunidades ou assentamentos precários segundo IBGE ou/e Prefeitura',
        // },
        // {
        //   servico: 'metro',
        //   distancia: 1000,
        //   nome: 'Metrô',
        //   resultado: null,
        //   tipo: 'qtde',
        //   info: 'Metrô em 1km',
        // },
        // {
        //   servico: 'metro-planejado',
        //   distancia: 1000,
        //   nome: 'Metrô planejado',
        //   resultado: null,
        //   tipo: 'qtde',
        //   info: 'Estações planejadas de metrô, VLT ou monotrilho',
        // },
        // {
        //   servico: 'equipamentos-educacao',
        //   distancia: 500,
        //   nome: 'Equipamentos de Educaçaõ',
        //   resultado: null,
        //   tipo: 'qtde',
        //   info: 'Equipamentos de Educação em 1km',
        // },
        // {
        //   servico: 'area-alagamento',
        //   distancia: 500,
        //   nome: 'Área de alagamento',
        //   resultado: null,
        //   tipo: 'qtde',
        //   info: 'Áreas inundáveis ou Pontos de Alagamentos',
        // },
        // {
        //   servico: 'risco-geologico',
        //   distancia: 500,
        //   nome: 'Risco Geoloógico',
        //   resultado: null,
        //   tipo: 'qtde',
        //   info: 'Áreas de risco geológico',
        // },
        // {
        //   servico: 'shopping',
        //   distancia: 500,
        //   nome: 'Shopping',
        //   resultado: null,
        //   tipo: 'qtde',
        //   info: 'Shopping Centers',
        // },
        {
          servico: 'dom-total-faixa-renda-v2',
          distancia: 500,
          nome: 'Renda total Faixa Renda',
          resultado: null,
          tipo: 'valor',
          key: 'dom-total-faixa-renda-v2',
          format: (valor) => {
            return formatNumber(valor, 'currency')
          },
          info: 'Censo IBGE 2010 com valores corrigidos a IPCA.',
        },
        {
          servico: 'renda-mensal-domiciliar',
          distancia: 500,
          nome: 'Renda Mensal Domiciliar',
          resultado: null,
          tipo: 'valor',
          key: 'renda_mensal_domiciliar',
          format: (valor) => {
            return formatNumber(valor, 'currency')
          },
          info: 'Censo IBGE 2010 com valores corrigidos a IPCA.',
        },
        {
          servico: 'renda-domiciliar-intersect',
          distancia: 500,
          nome: 'Domicílios 2010',
          resultado: null,
          tipo: 'valor',
          key: 'dom_total',
          format: (valor) => {
            return formatNumber(valor, 'inteiro')
          },
          info: 'Domicílios Total',
        },
        {
          servico: 'populacao-domicilios-censo-2022',
          distancia: 500,
          nome: 'Domicilios 2022',
          resultado: null,
          tipo: 'valor',
          key: 'perc_dom_baixa_renda',
          format: (valor) => {
            return formatNumber(valor, 'inteiro') + '%'
          },
          info: 'Percentual Domicílios BAIXA Renda',
        },
        // {
        //   servico: 'renda-domiciliar-intersect',
        //   distancia: 500,
        //   nome: 'Domicílios ALTA Renda',
        //   resultado: null,
        //   tipo: 'valor',
        //   key: 'perc_dom_alta_renda',
        //   format: (valor) => {
        //     return formatNumber(valor, 'inteiro') + '%'
        //   },
        //   info: 'Percentual Domicílios ALTA Renda',
        // },
        // {
        //   servico: 'renda-domiciliar-intersect',
        //   distancia: 500,
        //   nome: 'Potencial Consumo Mensal',
        //   resultado: null,
        //   tipo: 'valor',
        //   key: 'potencial_de_consumo_mensal',
        //   format: (valor) => {
        //     return formatNumber(valor, 'inteiro')
        //   },
        //   info: 'Potencial Consumo',
        // },
        {
          servico: 'indice-verticalizacao',
          distancia: 500,
          nome: 'indice-verticalizacao',
          resultado: null,
          tipo: 'valor',
          key: 'indice_verticalizacao',
          format: (valor) => {
            return formatNumber(valor, 'inteiro') + '%'
          },
          info: 'Número de apartamentos em relação ao total de domicílios',
        },
        {
          servico: 'ivs',
          distancia: 500,
          nome: 'Índice vunerabilidade Social',
          resultado: null,
          tipo: 'valor',
          key: 'ivs',
          format: (valor) => {
            return formatNumber(valor, 'inteiro')
          },
          info: 'Índice de Vulnerabilidade Social. Indica proximidade a aglomerados subnormais, e áreas de conflito, tais como facções, milícias, e outras variáveis sóciodemográficas.',
        },
        {
          servico: 'supply-location-quality-index',
          distancia: 500,
          nome: 'Índice de Liquidez',
          resultado: null,
          tipo: 'valor',
          key: 'index_city',
          format: (valor) => {
            return formatNumber(valor, 'inteiro')
          },
          info: 'Índice de qualidade-oferta local (Liquidez)',
        },
      ]



      let geom:any = geometriaSelecionada  
      if (geometriaSelecionada.type === 'Feature') {
        geom = geometriaSelecionada.geometry  as unknown as Geometry
      }
      // let geom = geometriaSelecionada
      const geomRequestKey = JSON.stringify(geom)
      if (lastGeomRequestRef.current === geomRequestKey) {
        return
      }
      lastGeomRequestRef.current = geomRequestKey
      let center = turf.centroid(geom as turf.AllGeoJSON )
      const longitude = center?.geometry?.coordinates?.[0]
      const latitude = center?.geometry?.coordinates?.[1]
      if (longitude === undefined || latitude === undefined) {
        return
      }
      const jsonEncoded = btoa(unescape(encodeURIComponent(JSON.stringify(geom))))

      const servicosCarregado = await Promise.all(
        servicos.map(async (item) => {
          const url = `service/${item.servico}/${longitude}/${latitude}?distance=${item.distancia}&intersect=${jsonEncoded}`
          const result = await api.get(url)

          return {...item, resultado: result}
        })
      )
      setResultado(servicosCarregado)
      setCacheResult((prev) => ({...prev, sociodemografico: servicosCarregado}))
    }
    if (geometriaSelecionada) {
      loadservice()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [geometriaSelecionada])

  if (!resultado) {
    return <>Carregando...</>
  }
  const link = '#'
  const Link = ({id, children, title}) => (
    <OverlayTrigger overlay={<Tooltip id={id}>{title}</Tooltip>}>
      <a
        href={link}
        onClick={(event) => {
          event.preventDefault()
        }}
      >
        {children}
      </a>
    </OverlayTrigger>
  )
  function getServicoResult(resultado: PropsResultado, servicoName: string) {
    if (!resultado) {
      return []
    }
    const servico = resultado.find((item) => item.servico === servicoName)
    return servico?.resultado?.itens || []
  }
  function getServicoResultByName(
    resultado: PropsResultado,
    servicoName: string,
    variavel: string
  ) {
    if (resultado) {
      const servico = resultado.find((item) => item.servico === servicoName)
      return servico?.resultado?.itens?.[0]?.[variavel]
    }
  }

  function getStyle(result, key) {
    let classStyle: string
    if (result['itens'].length > 0) {
      let valor = Number(result['itens'][0][key])

      if (valor <= 50) {
        classStyle = 'danger'
      } else if (valor <= 75) {
        classStyle = 'warning'
      } else if (valor <= 100) {
        classStyle = 'success'
      } else {
        classStyle = 'info'
      }
      return classStyle
    } else {
      return false
    }
  }

  function getStyleInverse(valor) {
    let classStyle: string
    if (valor) {
      // let valor = Number(result['itens'][0][key])

      if (valor <= 25) {
        classStyle = 'success'
      } else if (valor <= 50) {
        classStyle = 'warning'
      } else {
        classStyle = 'danger'
      }
      return classStyle
    } else {
      return false
    }
  }

  // servico.id === 45
  //   ? getStyleInverse(result, servico.chart_column_x)

  
  const valor = getServicoResultByName(resultado, 'ivs', 'ivs')
  const style = getStyleInverse(valor)

  const valorIndex = getServicoResultByName(resultado, 'supply-location-quality-index', 'index')
  const styleIndex = getStyleInverse(valorIndex)

  function getdensidade() {
    const clasificacao = Number(
      getServicoResultByName(resultado, 'renda-domiciliar-intersect', 'densidade_hab_ha')
    )

    if (!Number.isFinite(clasificacao)) {
      return undefined
    }
    if (clasificacao < 30) {
      return 'Muito Baixa'
    } else if (clasificacao >= 30 && clasificacao < 80) {
      return 'Baixa'
    } else if (clasificacao >= 80 && clasificacao < 150) {
      return 'Média'
    } else if (clasificacao >= 150 && clasificacao < 300) {
      return 'Alta'
    } else if (clasificacao >= 300) {
      return 'Muito Alta'
    }
  }

  function getdom_total() {
    const dom_total_2010 = Number(
      getServicoResultByName(resultado, 'renda-domiciliar-intersect', 'dom_total')
    )
    const dom_total_2022 = Number(
      getServicoResultByName(resultado, 'populacao-domicilios-censo-2022', 'domicilios')
    )
    if (!Number.isFinite(dom_total_2010) || dom_total_2010 === 0) {
      return 0
    }
    const percental = Math.round((dom_total_2022 / dom_total_2010 - 1) * 100)
    if (!Number.isFinite(percental)) {
      return 0
    }
    return percental
  }

  let totalFaixas = 0
  let listaFaixas = getServicoResult(resultado, 'dom-total-faixa-renda-v2')
  let faixas = [
    ['Faixa 1', 0, 2850, 'faixa_14'],
    ['Faixa 2', 2850, 4700, 'faixa_15'],
    ['Faixa 3', 4700, 8600, 'faixa_16'],
    ['Faixa 4', 8600, 12000, 'faixa_17'],
    ['Média Alta Renda', 12000, 20000, 'faixa_18'],
    ['Alta Renda', 20000, 30000, 'faixa_19'],
    ['Altíssima Renda', 30000, 0, 'faixa_20'],
  ]
  if (listaFaixas.length > 0) {
    listaFaixas = listaFaixas.map((item) => {
      const faixaMatch = faixas.find((faixa) => faixa[3] === item.id_faixa)
      return {
        ...item,
        faixa_renda: faixaMatch ? faixaMatch[0] : item.faixa_renda,
      }
    })

    listaFaixas = listaFaixas.filter((item) => {
      return item.faixa === 'baixa_renda'
    })
    totalFaixas = listaFaixas.reduce((acc, curr) => {
      return curr.faixa === 'baixa_renda' ? acc + Number(curr.total_dom || 0) : acc
    }, 0)
  }
  const densidadeLabel = getdensidade()
  const densidadeValue = getServicoResultByName(
    resultado,
    'renda-domiciliar-intersect',
    'densidade_hab_ha'
  )


  function fixeText(item) {
    switch (item) {
      case 'S?O PAULO':
        return 'São Paulo'
      default:
        return item
    }
  }
  const rendaMensalDomiciliar = getServicoResult(resultado, 'renda-mensal-domiciliar')
  return (
    <>
      <div>
        <div className='row row-cols-3  mt-5'>
          <div className='h-100px w-100 mb-10'>
            <h2 className='mb-0'>Faixa de renda</h2>
            <SegmentedProgressBar segments={listaFaixas} total={totalFaixas}></SegmentedProgressBar>
          </div>
        </div>
        <div className='row row-cols-3  mt-5'>
          <div className='col'>
            <BoxGaugue
              className='card-xl-stretch mb-xl-8'
              chartColor={style || ''}
              chartHeight='150px'
              titulo={'IVS'}
              valor={Number(valor)}
              descricaoCurta={'Vulnerabilidade Social'}
            />
          </div>
          <div className='col'>
            <BoxGaugue
              className='card-xl-stretch mb-xl-8'
              chartColor={styleIndex || ''}
              chartHeight='150px'
              titulo={'Urbit Score'}
              valor={Number(valorIndex)}
              descricaoCurta={'Urbit Score'}
            />
          </div>

          <div className='col'>
            <BoxGaugue
              className='card-xl-stretch mb-xl-8'
              chartColor={style || ''}
              chartHeight='120px'
              titulo={'Verticalização'}
              valor={Number(
                getServicoResultByName(
                  resultado,
                  'indice-verticalizacao',
                  'indice_verticalizacao'
                ) || 0
              )}
              descricaoCurta={'Verticalização'}
            />
          </div>
        </div>
        <div className='row row-cols-2 '>
          <div className='col'>
            <BoxValores
              texto={
                densidadeValue !== undefined && densidadeValue !== null
                  ? `${densidadeValue} Hab/Ha`
                  : '-'
              }
              titulo={densidadeLabel + ' Densidade'}
              subtitulo='Censo 2022'
            />
          </div>
         
            {rendaMensalDomiciliar.length > 0 &&

            rendaMensalDomiciliar.length ===  1 ? 
             <div className='col'><BoxValores
                    texto={
                      formatNumber(Number(rendaMensalDomiciliar[0].renda_mensal_domiciliar), 'currency_inteiro') + ''
                    }
                    titulo={'Renda média domiciliar '}
                    subtitulo={'Data base dez/2025'}
                  /></div>
                   : 
              rendaMensalDomiciliar.map((item) => {

                return ( <div className='col'>
                  <BoxValores
                    texto={
                      formatNumber(Number(item.renda_mensal_domiciliar), 'currency_inteiro') + ''
                    }
                    titulo={'Renda média domiciliar em ' + fixeText(item.municipio)}
                    subtitulo={'Data base dez/2025'}
                  />
                      </div>
                )
              }) 
            
            }
      
          <div className='col'>
            <BoxValores
              texto={formatNumber(
                getServicoResultByName(resultado, 'renda-domiciliar-intersect', 'pop_total'),
                'inteiro'
              )}
              titulo='Habitantes'
              subtitulo={'Censo 2022'}
            />
          </div>
          <div className='col '>
            <div
              className='card bgi-no-repeat card-xl-stretch mb-xl-8 border-2 box-performance'
              style={{
                backgroundPosition: 'right top',
                backgroundSize: '30%',
                backgroundImage: "url('/media/svg/shapes/abstract-4.svg')",
              }}
            >
              <div className='card-body'>
                <p className='text-gray-900-75 fw-semibold fs-1 m-0'>
                  {formatNumber(
                    getServicoResultByName(resultado, 'renda-domiciliar-intersect', 'dom_total'),
                    'inteiro'
                  )}
                </p>
                <div className='card-title fw-bold fs-4'>
                  Domicílios {getdom_total()} %
                  {getdom_total() > 0 ? (
                    <BsFillCaretUpFill
                      className='bg-green'
                      style={{color: 'green'}}
                      size={26}
                    ></BsFillCaretUpFill>
                  ) : (
                    <BsFillCaretDownFill
                      className='bg-green'
                      style={{color: 'red'}}
                      size={26}
                    ></BsFillCaretDownFill>
                  )}
                </div>
                <small>Em comparação a 2010</small>
              </div>
            </div>
          </div>
          <div className='col'>
            <BoxValores
              texto={getServicoResultByName(resultado, 'renda-domiciliar-intersect', 'hab_dom')}
              titulo='Hab. por dom'
            />
          </div>
          <div className='col'>
            <BoxValores
              texto={getServicoResultByName(
                resultado,
                'renda-domiciliar-intersect',
                'indice_envelhecimento'
              )}
              titulo='índice de Envelhecimento'
            />
          </div>
          <div className='col'>
            <BoxValores
              texto={formatNumber(
                getServicoResultByName(resultado, 'renda-domiciliar-intersect', 'pop_0_14'),
                'inteiro'
              )}
              titulo='Habitantes Abaixo de 15 anos '
            />
          </div>
          <div className='col'>
            <BoxValores
              texto={formatNumber(
                getServicoResultByName(resultado, 'renda-domiciliar-intersect', 'pop_15_64'),
                'inteiro'
              )}
              titulo='Habitantes Entre 15 e 64 anos '
            />
          </div>
          <div className='col'>
            <BoxValores
              texto={formatNumber(
                getServicoResultByName(resultado, 'renda-domiciliar-intersect', 'pop_65_mais'),
                'inteiro'
              )}
              titulo='Habitantes Acima de 65 anos '
            />
          </div>
        </div>
        {/* <div className='row row-cols-3' style={{flex: 'grid'}}>
          <div className='col border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3'>
            <div className='d-flex align-items-center'>
              <span className='svg-icon fs-3 text-success me-2'>45 Hab. por hectare</span>
          
            </div>

            <div className='fw-semibold fs-6 '>Densidade Baixa</div>
          </div>
          <div className='col border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3'>
            <div className='d-flex align-items-center'>
              <span className='svg-icon fs-3 text-success me-2'>10.000 Habitantes</span>
           
            </div>

            <div className='fw-semibold fs-6 '>Decrêncimo de 33%</div>
          </div>
          <div className='col border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3'>
            <div className='d-flex align-items-center'>
              <span className='svg-icon fs-3 text-success me-2'>R$20.500,00</span>
             
            </div>

            <div className='fw-semibold fs-6 '>Renda Domiciliar</div>
          </div>
          <div className='col border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3'>
            <div className='d-flex align-items-center'>
              <span className='svg-icon fs-3 text-success me-2'>5.000 Domicílios</span>
            </div>

            <div className='fw-semibold fs-6 '>Decrêncimo de 28%</div>
          </div>
          <div className='col border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3'>
            <div className='d-flex align-items-center'>
              <span className='svg-icon fs-3 text-success me-2'>2,0 habitantes por dom.</span>
          
            </div>

            <div className='fw-semibold fs-6 '>Decrêncimo de 42%</div>
          </div>
          <div className='col border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3'>
            <div className='d-flex align-items-center'>
              <span className='svg-icon fs-3 text-success me-2'>1,5 índice de Evelhecimento</span>
            </div>

            <div className='fw-semibold fs-6 '>Renda Domiciliar</div>
          </div>
          <div className='col border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3'>
            <div className='d-flex align-items-center'>
              <span className='svg-icon fs-3 text-success me-2'>2.000 Jovens</span>
            </div>

            <div className='fw-semibold fs-6 '>Abaixo de 15 anos (xx%)</div>
          </div>
          <div className='col border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3'>
            <div className='d-flex align-items-center'>
              <span className='svg-icon fs-3 text-success me-2'>5.000 Adultos</span>
            </div>

            <div className='fw-semibold fs-6 '>Entre 15 e 55 anos (xx%)</div>
          </div>

          <div className='col border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3'>
            <div className='d-flex align-items-center'>
              <span className='svg-icon fs-3 text-success me-2'>3.000 Idosos</span>
            </div>

            <div className='fw-semibold fs-6 '>Abaixo de 65 anos (xx%)</div>
          </div>
        </div> */}
      </div>
      {/* <table className='table table-row-dashed table-row-gray-300 gy-2'>
        <thead>
          <tr className='fw-bolder fs-6 text-gray-800'>
            <th>Indicador</th>
            <th className='text-center'>Valor/Qtde</th>
            <th className='text-center'>Lista </th>
          </tr>
        </thead>
        <tbody>
          {resultado ? (
            resultado.map((item, index) => {
              return (
                <tr key={index}>
                  <td>
                    <Link id={index} title={item.info}>
                      <BiInfoCircle className='fs-1 me-2'></BiInfoCircle>
                    </Link>
                    {item.nome} ({formatDistancia(item.distancia)})
                  </td>
                  <td className='w-80px text-center'>
                    {item.resultado ? (
                      item.resultado.itens.length > 0 ? (
                        item.tipo === 'qtde' ? (
                          <span className=' text-right fs-semibold'>{item.resultado.total}</span>
                        ) : (
                          <span className=' text-right fs-semibold'>
                            {item.format(item.resultado.itens[0][item.key])}
                          </span>
                        )
                      ) : (
                        <span className='badge badge-warning'>Não</span>
                      )
                    ) : null}
                  </td>
                  <td className='text-center'>
                    {item.resultado ? (
                      item.tipo === 'qtde' && item.resultado.itens.length > 0 ? (
                        <ModalServices list={item.resultado.itens}></ModalServices>
                      ) : null
                    ) : null}
                  </td>
                </tr>
              )
            })
          ) : (
            <tr>
              <td className='text-center' colSpan={2}>
                {' '}
                <div>Carregando</div>{' '}
              </td>
            </tr>
          )}
        </tbody>
      </table> */}
    </>
  )
}
